export default __webpack_public_path__ + "static/media/31_photo.c587c676.jpeg";